import React, { useState, useEffect } from 'react';

const SHOWS = [
  { id: 'euro2026sf1',   name: 'SEMI-FINAL 1', startUtc: '2026-05-12T19:00:00Z' },
  { id: 'euro2026sf2',   name: 'SEMI-FINAL 2', startUtc: '2026-05-14T19:00:00Z' },
  { id: 'euro2026final', name: 'GRAND FINAL',  startUtc: '2026-05-16T19:00:00Z' },
];

function pad(n) { return String(n).padStart(2, '0'); }

function nextShow(now) {
  return SHOWS.find(s => new Date(s.startUtc).getTime() > now) || null;
}

function formatRemaining(ms) {
  if (ms <= 0) return { d: 0, h: 0, m: 0, s: 0 };
  const s = Math.floor(ms / 1000) % 60;
  const m = Math.floor(ms / 60000) % 60;
  const h = Math.floor(ms / 3600000) % 24;
  const d = Math.floor(ms / 86400000);
  return { d, h, m, s };
}

const Countdown = () => {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const iv = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(iv);
  }, []);

  const show = nextShow(now);
  const live = SHOWS.find(s => {
    const start = new Date(s.startUtc).getTime();
    return now >= start && now < start + 3 * 60 * 60 * 1000;
  });

  if (live) {
    return (
      <div
        className="mb-5 px-3 py-2 flex items-center justify-between animate-slide-up"
        style={{
          background: 'linear-gradient(90deg, rgba(255,45,135,0.15), rgba(124,58,237,0.15))',
          border: '1px solid rgba(255,45,135,0.3)',
        }}
      >
        <span style={{ color: 'var(--pink)', fontSize: '11px', fontWeight: 700, letterSpacing: '2px' }}>
          ● {live.name} LIVE NOW
        </span>
      </div>
    );
  }

  if (!show) return null;

  const r = formatRemaining(new Date(show.startUtc).getTime() - now);

  return (
    <div
      className="mb-5 px-3 py-2.5 animate-slide-up"
      style={{
        background: 'var(--surface)',
        border: '1px solid var(--border)',
      }}
    >
      <div className="flex items-center justify-between">
        <span
          className="font-display"
          style={{ fontSize: '10px', fontWeight: 600, letterSpacing: '2px', color: 'var(--text3)' }}
        >
          {show.name} IN
        </span>
        <div
          className="font-mono tabular-nums"
          style={{
            fontFamily: '"JetBrains Mono", monospace',
            fontSize: '14px',
            fontWeight: 700,
            color: 'var(--text)',
            letterSpacing: '1px',
          }}
        >
          {r.d > 0 && <span style={{ color: 'var(--pink)' }}>{r.d}d </span>}
          <span>{pad(r.h)}</span>
          <span style={{ color: 'var(--text3)', margin: '0 2px' }}>:</span>
          <span>{pad(r.m)}</span>
          <span style={{ color: 'var(--text3)', margin: '0 2px' }}>:</span>
          <span style={{ color: 'var(--gold)' }}>{pad(r.s)}</span>
        </div>
      </div>
    </div>
  );
};

export default Countdown;
